import React from 'react'

const LvTranslationIcon = ({ classes }) => {
  return <i className={classes} />
}

export default LvTranslationIcon
